import { render, staticRenderFns } from "./ProgressCircle.vue?vue&type=template&id=72fe90df&lang=pug&"
var script = {}
import style0 from "./ProgressCircle.vue?vue&type=style&index=0&id=72fe90df&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports